// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"de780f8c","280":"08a8111b","312":"606baa61","392":"4e20bbde","529":"5a6557e3","676":"9f4762a2","828":"7d095b91"}[chunkId] + ".chunk.css";
};